// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appointment_stepper_wrapper {
	width: 100%;
}
@media (max-width: 575px) {
	.appointment_stepper_wrapper {
		overflow-x: auto;
	}
}
.appointmnt_setps {
	display: flex;
	align-items: stretch;
	background: var(--steps-background);
	border-bottom: 1px solid var(--steps-border-color);
	padding: 16px 0;
	overflow: hidden;
	min-width: 500px;
}

.grey_bg {
	background: #f2f0fa !important;
}
@media (max-width: 575px) {
	.appointmnt_setps {
		flex-direction: row !important;
	}
}
.appointmnt_setps .ant-steps-item {
	padding: 0 !important;
	width: 100%;
	flex: auto !important;
	overflow: visible !important;
}

.appointmnt_setps .ant-steps-item .ant-steps-item-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
}

.appointmnt_setps .ant-steps-item .ant-steps-item-tail {
	display: flex !important;
	top: 15px !important;
	width: 60px;
	right: -28px !important;
	left: auto !important;
	background-color: transparent !important;
	border-bottom: 1px dashed var(--primary-color);
	margin: 0 !important;
	padding: 0 !important;
}
@media (max-width: 575px) {
	.appointmnt_setps .ant-steps-item .ant-steps-item-tail {
		top: 15px !important;
		width: 56px !important;
		height: auto !important;
		right: -28px !important;
	}
}

.appointmnt_setps .ant-steps-item .ant-steps-item-tail::after {
	background-color: transparent !important;
}

.ant-steps-item-active .ant-steps-item .ant-steps-item-tail {
	background-color: transparent;
}

.appointmnt_setps .ant-steps-item:last-child .ant-steps-item-tail {
	display: none !important;
}

.appointmnt_setps .ant-steps-item-container .ant-steps-item-icon {
	margin: 0;
	background-color: var(--white-color);
	border: 1px solid var(--white-color);
}
@media (max-width: 575px) {
	.appointmnt_setps .ant-steps-item-container .ant-steps-item-icon {
		margin: 0 !important;
	}
}

.appointmnt_setps .ant-steps-item-container .ant-steps-icon {
	font-size: 13px;
	line-height: 12px;
	font-weight: 500;
	font-family: "Poppins", sans-serif;
	color: var(--dark-text-color) !important;
}

.ant-steps-item-active .ant-steps-item-container .ant-steps-icon,
.ant-steps-item-active .ant-steps-item-title {
	font-weight: 700 !important;
	color: var(--dark-text-color) !important;
}
.appointmnt_setps .ant-steps-item-content {
	width: auto !important;
	margin: 0 !important;
}
@media (max-width: 575px) {
	.appointmnt_setps .ant-steps-item-content {
		min-height: auto !important;
	}
}
.appointmnt_setps .ant-steps-item-title {
	padding: 0;
	font-size: 10.4px;
	font-family: "Poppins", sans-serif;
	font-weight: 400;
	line-height: 16px;
	letter-spacing: 0.02em;
	color: var(--dark-text-color) !important;
	text-transform: uppercase;
}
@media (max-width: 575px) {
	.appointmnt_setps .ant-steps-item-title {
		font-size: 10.4px !important;
		font-weight: 400;
		line-height: 16px !important;
		letter-spacing: 0.02em !important;
	}
}

.appointmnt_setps .ant-steps-item-title::after {
	display: none;
}

.appointmnt_setps .ant-steps-item-finish .ant-steps-item-icon {
	background-color: var(--primary-color) !important;
}

.appointmnt_setps .ant-steps-item-finish svg path {
	fill: var(--white-color);
}

.steps_content_finish {
	height: 100%;
}

.steps_content_main {
	height: calc(100vh - 186px);
	overflow-y: auto;
}
@media (max-width: 575px) {
	.steps_content_main {
		height: calc(100vh - 180px) !important;
	}
}
.steps_content_main .steps_content_inr {
	padding: 16px 24px;
}

.steps_content_main::-webkit-scrollbar {
	width: 6px;
}

.steps_content_main::-webkit-scrollbar-thumb {
	background: #a3a3a3;
}

.steps_btn {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px;
	background-color: var(--steps-background);
}

.steps_btn .steps_button {
	display: flex;
	align-items: center;
	gap: 8px;
	color: var(--dark-text-color);
	border: 1px solid var(--white-color);
	background-color: var(--white-color);
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
	padding: 8px 12px;
	height: auto !important;
	border-radius: 50px;
	-webkit-border-radius: 50px;
	-moz-border-radius: 50px;
	-ms-border-radius: 50px;
	-o-border-radius: 50px;
}

.steps_btn .steps_button:hover {
	border: 1px solid var(--white-color) !important;
	background-color: var(--white-color) !important;
	color: var(--dark-text-color) !important;
}

.steps_btn .steps_button .button_icon {
	width: 13px;
	height: 13px;
}

.steps_btn .steps_button .button_text {
	font-size: 14px;
	line-height: 16px;
	font-weight: 600;
	font-family: "Poppins", sans-serif;
	color: var(--dark-text-color);
}

.steps_btn .next_button {
	border: 1px solid var(--primary-color) !important;
	background-color: var(--primary-color) !important;
	color: var(--white-color) !important;
}

.next_button.clicked,
.back_button.clicked {
	opacity: 0.5;
	cursor: auto !important;
}

.back_button.clicked {
	opacity: 0.5;
	cursor: auto !important;
}

.steps_btn .next_button .button_text {
	color: var(--white-color);
}

.steps_btn .next_button:hover {
	border: 1px solid var(--primary-color) !important;
	background-color: var(--primary-color) !important;
	color: var(--white-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/General/Stepper/Stepper.css"],"names":[],"mappings":"AAAA;CACC,WAAW;AACZ;AACA;CACC;EACC,gBAAgB;CACjB;AACD;AACA;CACC,aAAa;CACb,oBAAoB;CACpB,mCAAmC;CACnC,kDAAkD;CAClD,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;AAC/B;AACA;CACC;EACC,8BAA8B;CAC/B;AACD;AACA;CACC,qBAAqB;CACrB,WAAW;CACX,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,wBAAwB;CACxB,oBAAoB;CACpB,WAAW;CACX,uBAAuB;CACvB,qBAAqB;CACrB,wCAAwC;CACxC,8CAA8C;CAC9C,oBAAoB;CACpB,qBAAqB;AACtB;AACA;CACC;EACC,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;CACxB;AACD;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,SAAS;CACT,oCAAoC;CACpC,oCAAoC;AACrC;AACA;CACC;EACC,oBAAoB;CACrB;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,kCAAkC;CAClC,wCAAwC;AACzC;;AAEA;;CAEC,2BAA2B;CAC3B,wCAAwC;AACzC;AACA;CACC,sBAAsB;CACtB,oBAAoB;AACrB;AACA;CACC;EACC,2BAA2B;CAC5B;AACD;AACA;CACC,UAAU;CACV,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;CAChB,iBAAiB;CACjB,sBAAsB;CACtB,wCAAwC;CACxC,yBAAyB;AAC1B;AACA;CACC;EACC,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;CAClC;AACD;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;AACjB;AACA;CACC;EACC,sCAAsC;CACvC;AACD;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,YAAY;CACZ,yCAAyC;AAC1C;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,6BAA6B;CAC7B,oCAAoC;CACpC,oCAAoC;CACpC,2CAA2C;CAC3C,iBAAiB;CACjB,uBAAuB;CACvB,mBAAmB;CACnB,2BAA2B;CAC3B,wBAAwB;CACxB,uBAAuB;CACvB,sBAAsB;AACvB;;AAEA;CACC,+CAA+C;CAC/C,+CAA+C;CAC/C,wCAAwC;AACzC;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,kCAAkC;CAClC,6BAA6B;AAC9B;;AAEA;CACC,iDAAiD;CACjD,iDAAiD;CACjD,oCAAoC;AACrC;;AAEA;;CAEC,YAAY;CACZ,uBAAuB;AACxB;;AAEA;CACC,YAAY;CACZ,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,iDAAiD;CACjD,iDAAiD;CACjD,oCAAoC;AACrC","sourcesContent":[".appointment_stepper_wrapper {\n\twidth: 100%;\n}\n@media (max-width: 575px) {\n\t.appointment_stepper_wrapper {\n\t\toverflow-x: auto;\n\t}\n}\n.appointmnt_setps {\n\tdisplay: flex;\n\talign-items: stretch;\n\tbackground: var(--steps-background);\n\tborder-bottom: 1px solid var(--steps-border-color);\n\tpadding: 16px 0;\n\toverflow: hidden;\n\tmin-width: 500px;\n}\n\n.grey_bg {\n\tbackground: #f2f0fa !important;\n}\n@media (max-width: 575px) {\n\t.appointmnt_setps {\n\t\tflex-direction: row !important;\n\t}\n}\n.appointmnt_setps .ant-steps-item {\n\tpadding: 0 !important;\n\twidth: 100%;\n\tflex: auto !important;\n\toverflow: visible !important;\n}\n\n.appointmnt_setps .ant-steps-item .ant-steps-item-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.appointmnt_setps .ant-steps-item .ant-steps-item-tail {\n\tdisplay: flex !important;\n\ttop: 15px !important;\n\twidth: 60px;\n\tright: -28px !important;\n\tleft: auto !important;\n\tbackground-color: transparent !important;\n\tborder-bottom: 1px dashed var(--primary-color);\n\tmargin: 0 !important;\n\tpadding: 0 !important;\n}\n@media (max-width: 575px) {\n\t.appointmnt_setps .ant-steps-item .ant-steps-item-tail {\n\t\ttop: 15px !important;\n\t\twidth: 56px !important;\n\t\theight: auto !important;\n\t\tright: -28px !important;\n\t}\n}\n\n.appointmnt_setps .ant-steps-item .ant-steps-item-tail::after {\n\tbackground-color: transparent !important;\n}\n\n.ant-steps-item-active .ant-steps-item .ant-steps-item-tail {\n\tbackground-color: transparent;\n}\n\n.appointmnt_setps .ant-steps-item:last-child .ant-steps-item-tail {\n\tdisplay: none !important;\n}\n\n.appointmnt_setps .ant-steps-item-container .ant-steps-item-icon {\n\tmargin: 0;\n\tbackground-color: var(--white-color);\n\tborder: 1px solid var(--white-color);\n}\n@media (max-width: 575px) {\n\t.appointmnt_setps .ant-steps-item-container .ant-steps-item-icon {\n\t\tmargin: 0 !important;\n\t}\n}\n\n.appointmnt_setps .ant-steps-item-container .ant-steps-icon {\n\tfont-size: 13px;\n\tline-height: 12px;\n\tfont-weight: 500;\n\tfont-family: \"Poppins\", sans-serif;\n\tcolor: var(--dark-text-color) !important;\n}\n\n.ant-steps-item-active .ant-steps-item-container .ant-steps-icon,\n.ant-steps-item-active .ant-steps-item-title {\n\tfont-weight: 700 !important;\n\tcolor: var(--dark-text-color) !important;\n}\n.appointmnt_setps .ant-steps-item-content {\n\twidth: auto !important;\n\tmargin: 0 !important;\n}\n@media (max-width: 575px) {\n\t.appointmnt_setps .ant-steps-item-content {\n\t\tmin-height: auto !important;\n\t}\n}\n.appointmnt_setps .ant-steps-item-title {\n\tpadding: 0;\n\tfont-size: 10.4px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 400;\n\tline-height: 16px;\n\tletter-spacing: 0.02em;\n\tcolor: var(--dark-text-color) !important;\n\ttext-transform: uppercase;\n}\n@media (max-width: 575px) {\n\t.appointmnt_setps .ant-steps-item-title {\n\t\tfont-size: 10.4px !important;\n\t\tfont-weight: 400;\n\t\tline-height: 16px !important;\n\t\tletter-spacing: 0.02em !important;\n\t}\n}\n\n.appointmnt_setps .ant-steps-item-title::after {\n\tdisplay: none;\n}\n\n.appointmnt_setps .ant-steps-item-finish .ant-steps-item-icon {\n\tbackground-color: var(--primary-color) !important;\n}\n\n.appointmnt_setps .ant-steps-item-finish svg path {\n\tfill: var(--white-color);\n}\n\n.steps_content_finish {\n\theight: 100%;\n}\n\n.steps_content_main {\n\theight: calc(100vh - 186px);\n\toverflow-y: auto;\n}\n@media (max-width: 575px) {\n\t.steps_content_main {\n\t\theight: calc(100vh - 180px) !important;\n\t}\n}\n.steps_content_main .steps_content_inr {\n\tpadding: 16px 24px;\n}\n\n.steps_content_main::-webkit-scrollbar {\n\twidth: 6px;\n}\n\n.steps_content_main::-webkit-scrollbar-thumb {\n\tbackground: #a3a3a3;\n}\n\n.steps_btn {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 8px;\n\tbackground-color: var(--steps-background);\n}\n\n.steps_btn .steps_button {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tcolor: var(--dark-text-color);\n\tborder: 1px solid var(--white-color);\n\tbackground-color: var(--white-color);\n\tbox-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);\n\tpadding: 8px 12px;\n\theight: auto !important;\n\tborder-radius: 50px;\n\t-webkit-border-radius: 50px;\n\t-moz-border-radius: 50px;\n\t-ms-border-radius: 50px;\n\t-o-border-radius: 50px;\n}\n\n.steps_btn .steps_button:hover {\n\tborder: 1px solid var(--white-color) !important;\n\tbackground-color: var(--white-color) !important;\n\tcolor: var(--dark-text-color) !important;\n}\n\n.steps_btn .steps_button .button_icon {\n\twidth: 13px;\n\theight: 13px;\n}\n\n.steps_btn .steps_button .button_text {\n\tfont-size: 14px;\n\tline-height: 16px;\n\tfont-weight: 600;\n\tfont-family: \"Poppins\", sans-serif;\n\tcolor: var(--dark-text-color);\n}\n\n.steps_btn .next_button {\n\tborder: 1px solid var(--primary-color) !important;\n\tbackground-color: var(--primary-color) !important;\n\tcolor: var(--white-color) !important;\n}\n\n.next_button.clicked,\n.back_button.clicked {\n\topacity: 0.5;\n\tcursor: auto !important;\n}\n\n.back_button.clicked {\n\topacity: 0.5;\n\tcursor: auto !important;\n}\n\n.steps_btn .next_button .button_text {\n\tcolor: var(--white-color);\n}\n\n.steps_btn .next_button:hover {\n\tborder: 1px solid var(--primary-color) !important;\n\tbackground-color: var(--primary-color) !important;\n\tcolor: var(--white-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
